import { useDispatch, useSelector } from 'react-redux';
import { selectAgentDisplayTimezone } from 'app/modules/session/selectors';
import {
  selectOrgDisplayTimezone,
  selectOrgTagLimit,
} from 'app/modules/orgSettings/selectors';
import { selectAllTags } from 'app/modules/teamsOld/selectors';
import { useEffect, useRef } from 'react';
import { setDefaultTimezoneOptions } from 'app/shared/utils/date';
import { sendErrorToast } from 'app/shared/toasts/actions';
import { getTagLimitReachedError } from 'app/shared/helpers';

export const useTimezoneSync = () => {
  const agentTimezone = useSelector(selectAgentDisplayTimezone);
  const orgTimezone = useSelector(selectOrgDisplayTimezone);
  const timezone = agentTimezone || orgTimezone;

  useEffect(() => {
    if (timezone) {
      setDefaultTimezoneOptions({ timezone, showTimezone: true });
    } else {
      setDefaultTimezoneOptions({});
    }
  }, [timezone]);

  return timezone;
};

export const useTagLimitToast = (orgSettingsLoaded: boolean) => {
  const dispatch = useDispatch();
  const tagLimit = useSelector(selectOrgTagLimit);
  const tags = useSelector(selectAllTags);
  const tagCount = Object.keys(tags).length;
  const hasToastedRef = useRef(false);

  useEffect(() => {
    if (!orgSettingsLoaded || hasToastedRef.current) {
      return;
    }

    if (tagCount > tagLimit) {
      dispatch(sendErrorToast(getTagLimitReachedError(tagCount, tagLimit)));
      hasToastedRef.current = true;
    }
  }, [dispatch, orgSettingsLoaded, tagCount, tagLimit]);
};
